<style>
    .c-product-grid,
    .c-product-grid .product-image {
        position: relative
    }

    .c-product-grid .product-image {
        min-height: 300px;
        max-height: 300px;
        overflow: hidden;
    }

    .c-product-grid {
        text-align: center;
        border-radius: 2px;
        overflow: hidden;
        z-index: 1;
        transition: all .3s ease 0s
    }

    .c-product-grid:hover {
        box-shadow: 0 0 10px rgba(0, 0, 0, .2)
    }

    .c-product-grid .product-image a {
        display: block
    }

    .c-product-grid .product-image img {
        width: 100%;
    }

    .c-product-grid .social {
        width: 180px;
        padding: 0;
        margin: 0 auto;
        list-style: none;
        position: absolute;
        right: 0;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        transition: all .1s ease 0s
    }

    .c-product-grid .social li {
        display: inline-block;
        opacity: 0;
        transition: all .7s
    }

    .c-product-grid .social li:nth-child(1) {
        transition-delay: .15s
    }

    .c-product-grid .social li:nth-child(2) {
        transition-delay: .3s
    }

    .c-product-grid .social li:nth-child(3) {
        transition-delay: .45s
    }

    .c-product-grid:hover .social li {
        opacity: 1
    }

    .c-product-grid .social li a {
        color: #222;
        background: #fff;
        font-size: 17px;
        line-height: 36px;
        width: 40px;
        height: 36px;
        border-radius: 2px;
        margin: 0 5px;
        display: block;
        transition: all .3s ease 0s
    }

    .c-product-grid .social li a:hover {

    }

    .c-product-grid .social li a:after, .c-product-grid .social li a:before {
        content: attr(data-tip);
        color: #fff;
        background-color: #000;
        font-size: 12px;
        line-height: 20px;
        border-radius: 3px;
        padding: 0 5px;
        white-space: nowrap;
        opacity: 0;
        transform: translateX(-50%);
        position: absolute;
        left: 50%;
        top: -30px
    }

    .c-product-grid .social li a:after {
        content: '';
        height: 15px;
        width: 15px;
        border-radius: 0;
        transform: translateX(-50%) rotate(45deg);
        top: -22px;
        z-index: -1
    }

    .c-product-grid .social li a:hover:after, .c-product-grid .social li a:hover:before {
        opacity: 1
    }

    .c-product-grid .product-discount-label, .c-product-grid .product-new-label {
        color: #fff;
        background-color: #16a085;
        font-size: 13px;
        font-weight: 800;
        text-transform: uppercase;
        line-height: 45px;
        height: 45px;
        width: 45px;
        border-radius: 50%;
        position: absolute;
        left: 10px;
        top: 15px;
        transition: all .3s
    }

    .c-product-grid .product-discount-label {
        left: auto;
        right: 10px;
        background-color: #d7292a
    }

    .c-product-grid:hover .product-new-label {
        opacity: 0
    }

    .c-product-grid .product-content {
        padding: 25px
    }

    .c-product-grid .title {
        font-size: 15px;
        font-weight: 400;
        text-transform: capitalize;
        margin: 0 0 7px;
        transition: all .3s ease 0s
    }

    .c-product-grid .title a {
        color: #222
    }

    .c-product-grid .title a:hover {
        color: #16a085
    }

    .c-product-grid .price {
        font-size: 17px;
        font-weight: 700;
        margin: 0 2px 15px 0;
        display: block
    }

    .c-product-grid .price span {
        font-size: 13px;
        font-weight: 400;
        letter-spacing: 0;
        text-decoration: line-through;
        text-align: left;
        vertical-align: middle;
        display: inline-block
    }

    @media only screen and (max-width: 990px) {
        .c-product-grid {
            margin-bottom: 30px
        }
    }
</style>

<template>

    <div class="c-product-grid">
        <div class="product-image">
            <a href="#">
                <img :src="Core.Product.displayImage(dataProduct.image)">
            </a>
            <ul class="social">
                <li><a v-if="false" @click="$emit('onPreviewClick', dataSelectedProduct)" :data-tip="Core.Definition.getDefinition('Aperçu')"><i class="fa fa-eye"></i></a></li>
                <li><a v-if="false" @click="$emit('onAddToCartClick', dataSelectedProduct)" :data-tip="Core.Definition.getDefinition('Ajouter au panier')"><i class="fa fa-shopping-cart"></i></a></li>
                <li v-if="false"><a href="#" data-tip="Add to Wishlist"><i class="fa fa-shopping-bag"></i></a></li>
            </ul>
            <span v-if="false" class="product-new-label">New</span>
            <span v-if="false" class="product-discount-label">-10%</span>
        </div>
        <div class="product-content">
            <div v-if="dataProduct.variations !== undefined && dataProduct.variations.length > 0">
                <select class="form-control mb-2" v-model="dataSelectedProduct">
                    <option :value="dataProduct.variations[variationIndex]" v-for="variation, variationIndex in dataProduct.variations">{{variation.title}}</option>
                </select>
            </div>
            <h3 v-if="dataProduct.variations === undefined || dataProduct.variations.length === 0" class="title mb-4">{{dataProduct.title}}</h3>

            <div class="price">
                {{Core.Currency.format(dataSelectedProduct.regularPrice)}}
            </div>

            <b-row>
                <b-col lg="8">
                    <InputQuantity @change="onChange" @onPlus="onPlus" @onMinus="onMinus" v-model="dataSelectedProduct.quantity"></InputQuantity>
                </b-col>
                <b-col class="text-right" lg="4">
                    <b-button-group size="sm">
                        <b-button @click="$emit('onCartClick', dataSelectedProduct, dataProduct)"  class="btn btn-light"><b-badge class="animated fadeIn badge-success mr-2" v-if="cartCount !== false">{{cartCount}}</b-badge><i class="fa fa-shopping-cart"></i></b-button>
                    </b-button-group>
                </b-col>
            </b-row>
        </div>
    </div>

</template>

<script>
    import InputQuantity from './InputQuantity'
    export default {
        name: 'ProductGrid',
        components: {
            InputQuantity
        },
        props: {
            value: {
                type: Object,
                default: function () {
                    return {
                    }
                }
            }
        },
        watch: {
            value() {
                this.init()
            }
        },
        computed: {
            cartCount() {
                let productId = this.dataSelectedProduct.id
                let product = Core.Array.findByKey(Core.Session.Cart.products, 'id', productId)
                if (product !== false) {
                    return product.quantity
                }
                return false
            }
        },
        beforeMount() {
        },
        mounted() {
            this.init()
        },
        data: () => {
            return {
                Core: window.Core,
                dataProduct: {},
                dataSelectedProduct: {}
            }
        },
        methods: {
            init() {
                this.dataProduct = this.value
                if (this.dataProduct.variations !== undefined && this.dataProduct.variations.length > 0) {
                    this.dataSelectedProduct = this.dataProduct.variations[0]
                } else {
                    this.dataSelectedProduct = this.dataProduct
                }
                this.dataSelectedProduct.quantity = Core.Session.Cart.getQuantity(this.dataSelectedProduct.id)
            },
            onChange(quantity) {
                this.dataSelectedProduct.quantity = quantity
                this.$emit('onAddToCartClick', this.dataSelectedProduct)
            },
            onPlus(quantity) {
                this.dataSelectedProduct.quantity = quantity
                this.$emit('onAddToCartClick', this.dataSelectedProduct)
            },
            onMinus(quantity) {
                this.dataSelectedProduct.quantity = quantity
                this.$emit('onAddToCartClick', this.dataSelectedProduct)
            }
        }
    }
</script>